import { API } from 'aws-amplify';
import { GetTelemetryResult } from './telemetry.interfaces';

export type TelemetryQuery = {
  from?: number;
  to?: number;
  limit?: number;
};

export class TelemetryService {
  public constructor(private readonly apiName: string) {}

  public async getCameraTelemetry(cameraId: string, params?: TelemetryQuery): Promise<GetTelemetryResult> {
    return API.get(this.apiName, `/cameras/${cameraId}/telemetry`, {
      queryStringParameters: params ?? {},
    }) as any;
  }
}
